
<div class="conversations">
  @if (enableNew) {
    <button mat-button class="cta-button-buy"  mat-button (click)="openConversationDialog(offerId, 0);$event.stopPropagation()">
      Nouvelle<mat-icon>add</mat-icon>
    </button>
  }

  @if (!(conversations !== null  && conversations !== undefined && conversations.length > 0)) {
    <span>
      Aucune conversations en cours
    </span>
  }

  @if (!(conversations == null || conversations == undefined || conversations.length === 0 )) {
    <div class="conversation-list">
      @for (conversation of conversations; track conversation; let i = $index) {
        <div class="conversation" (click)="openConversationDialog(conversations[i].offerId, conversations[i].id)">
          <div class="summary">
            <!-- <b>[{{ (conversation.participants[0] === null)? 'EXT' : conversation.participants[0] }}]</b> -->
            @if (objectSource===ObjectSource.DEALER) {
              <h4>{{conversation.carDetails}} ({{conversation.businessLine}})</h4>
            }
            <h6 class="summary-details"><mat-icon>forum</mat-icon> N° {{conversation.id}}</h6>
            <h6 class="summary-details"><mat-icon>group</mat-icon> @for (participant of conversation.participants; track participant; let i = $index) {
            <span>@if (i!==0) {
              <span>, </span>
            }{{participant}} </span>
          }</h6>
        </div>
        <div class="messages">
          <h5>Derniers messages <mat-icon>open_in_new</mat-icon></h5>
          <!-- <mat-icon>sms</mat-icon>  -->
          @for (message of conversation.messages.slice().reverse(); track message; let i = $index; let isLast = $last) {
            <div>
              @if (conversation.messages) {
                <span class="message-brief">
                  <span>
                    <b>{{(currentUserId === message.senderId) ? 'Moi' : message.senderName}}</b>
                    : {{message.body}}
                  </span>
                  <span class="date" >
                    {{dateFormat(message.created)}}
                  </span>
                </span>
              }
            </div>
          }
          <!--
          <span class="message-brief" *ngIf="conversation.messages != undefined && conversation.messages!.length > 0">
            <b>
              {{(currentUserId === conversation.messages[conversation.messages.length-1].senderId)
              ?'(Moi)'
              :conversation.messages[conversation.messages.length-1].senderName +' ('+conversation.messages[conversation.messages.length-1].senderId+')'}}
            </b>
            : {{conversation.messages[conversation.messages.length-1].body}} ...
          </span> -->
        </div>
        <!-- <mat-icon [style.color]="'#000000'" [matBadge]="conversation.participants == undefined ? 0 : conversation.participants.length" matBadgeColor="primary">person</mat-icon>  -->
      </div>
    }
  </div>
}
</div>


<!-- <div *ngFor="let conversation of conversations; index as i">

<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title class="conversation-title">
      <h6>Conversation {{i}} </h6>

      <h6>



      </h6>


    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="message" [style]="(currentUserId === message.senderId)?'background-color:#eeeeee; margin-right:30%':'background-color:#e0ffff; margin-left:30%'" *ngFor="let message of conversation.messages; index as j">


    <h6> <b>{{(currentUserId === message.senderId)?'Me':message.senderName}}</b>: {{message.body}}</h6>



    <h6> {{dateFormat(message.date)}}
    </h6>

  </div>

  <div class="message-reply">
    <mat-form-field>
      <textarea matInput type="text"  name="reply" placeholder="Répondre"  [(ngModel)]="reply" ></textarea>
    </mat-form-field>

    <button matButton class="cta-button"  mat-button (click)="replyToMessage(reply, conversation.carId, conversation.id);$event.stopPropagation()">
      <mat-icon>send</mat-icon>
    </button>

  </div>
</mat-expansion-panel>
</div> -->